export default __webpack_public_path__ + "static/media/add_external_picture.010deb37.svg";